import DefaultRenderer from "./DefaultRenderer";

export function rendererFactory(stationType) {
  switch (stationType) {
    // case 'RELO': return new RELORenderer();
    // case 'SSD': return new SSDRenderer();
    default:
      return new DefaultRenderer();
  }
}



// WEBPACK FOOTER //
// ./src/components/mySCC/common/renderers/rendererFactory.js